import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { Bucket } from '../../types';

@Component({
  selector: 'app-category-bucket-summary-info',
  templateUrl: './category-bucket-summary-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe],
})
export class CategoryBucketSummaryInfoComponent {
  readonly bucket = input.required<Bucket>();
  LABELS: Record<'REMAINING' | 'OVER', Record<string, string>> = {
    REMAINING: {
      BUDGET: 'Remaining',
      INCOME: 'Expected',
    },
    OVER: {
      BUDGET: 'Exceeded',
      INCOME: 'Surplus',
    },
  };

  get remainingLabel() {
    return this.LABELS.REMAINING[this.bucket().type] ?? 'Remaining';
  }

  get monthsLeft(): number | undefined {
    const fund = this.bucket().fund;
    if (!fund?.goal) return undefined;
    return Math.round((fund.goal - (fund.balance ?? 0)) / this.bucket().amount);
  }

  get yearsLeft(): number | undefined {
    const fund = this.bucket().fund;
    if (!fund?.goal) return undefined;
    return Math.round(((fund.goal - (fund.balance ?? 0)) / this.bucket().amount / 12) * 10) / 10;
  }

  get remaining() {
    if (this.bucket().type === 'INCOME' && this.bucket().amount - this.bucket().total >= 0)
      return this.bucket().amount - this.bucket().total;
    if (this.bucket().type === 'INCOME' && this.bucket().amount - this.bucket().total < 0) return false;
    const fundBalance = this.bucket().fund?.balance;
    if (fundBalance !== undefined && fundBalance >= 0) return fundBalance;
    if (!this.bucket().fund && this.bucket().amount + this.bucket().total > 0) return this.bucket().amount + this.bucket().total;

    return false;
  }

  get overLabel() {
    return this.LABELS.OVER[this.bucket().type] ?? 'Exceeded';
  }

  get over() {
    if (this.bucket().type === 'INCOME' && this.bucket().amount - this.bucket().total < 0)
      return (this.bucket().amount - this.bucket().total) * -1;
    const fundBalance = this.bucket().fund?.balance;
    if (fundBalance !== undefined && fundBalance < 0) return fundBalance * -1;
    if (!this.bucket().fund && this.bucket().amount + this.bucket().total < 0)
      return (this.bucket().amount + this.bucket().total) * -1;
    return false;
  }

  get goal() {
    if (this.bucket().type === 'INCOME') return false;
    return this.bucket().fund?.goal ?? false;
  }

  get spent() {
    if (this.bucket().type === 'INCOME') return false;
    return this.bucket().total * -1;
  }

  get unsignedBucketTotal() {
    return Math.abs(this.bucket().total);
  }

  get earned() {
    if (this.bucket().type !== 'INCOME') return false;
    return this.bucket().total;
  }
  constructor() {}
}
